var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDeviceTypeChromebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 63,
    height: 63,
    viewBox: "0 0 63 63",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1209_6050)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 1.25,
    y: 1.51074,
    width: 60,
    height: 60,
    rx: 30,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.625 17.6936V45.3265C16.6252 45.3864 16.6431 45.445 16.6764 45.4948C16.7097 45.5446 16.757 45.5835 16.8124 45.6066C16.8677 45.6296 16.9286 45.6358 16.9875 45.6244C17.0463 45.613 17.1005 45.5844 17.1432 45.5423L31.5312 31.5108L17.1432 17.4778C17.1005 17.4357 17.0463 17.4071 16.9875 17.3957C16.9286 17.3843 16.8677 17.3905 16.8124 17.4135C16.757 17.4366 16.7097 17.4755 16.6764 17.5253C16.6431 17.5751 16.6252 17.6337 16.625 17.6936Z",
    fill: "#4739E7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.5641 25.7451L19.5233 15.8057L19.512 15.7994C19.2013 15.6306 18.9059 16.0511 19.1605 16.2958L33.3024 29.8183L37.5641 25.7451Z",
    fill: "#4739E7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.1619 46.7257C18.9059 46.9704 19.2012 47.3908 19.5134 47.2221L19.5247 47.2158L37.5641 37.2764L33.3024 33.2018L19.1619 46.7257Z",
    fill: "#4739E7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.847 29.7529L39.8091 26.9784L35.0722 31.5107L39.8091 36.041L44.847 33.2686C46.2174 32.5113 46.2174 30.5102 44.847 29.7529Z",
    fill: "#4739E7"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1.75,
    y: 2.01074,
    width: 59,
    height: 59,
    rx: 29.5,
    stroke: "#4739E7"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1209_6050",
    x: 0.25,
    y: 0.510742,
    width: 62,
    height: 62,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 1,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect1_dropShadow_1209_6050"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.878431 0 0 0 0 0.878431 0 0 0 0 0.878431 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1209_6050"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1209_6050",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeviceTypeChromebook);
export default __webpack_public_path__ + "static/media/device-type-chromebook.4138acbc8c04d678f90b8f28817fc2c5.svg";
export { ForwardRef as ReactComponent };